import { assetUrl } from 'utils/url'

export const navigation = [
  {
    id: 'pusat-bantuan',
    name: 'Pusat Bantuan Rumah Pendidikan',
    url: 'https://pengaduan.ult.kemendikdasmen.go.id/hc/en-gb/requests/new',
    target: '_blank',
    rel: 'noreferrer',
  },
  {
    id: 'syarat-dan-ketentuan',
    name: 'Syarat & Ketentuan',
    url: '/syarat-dan-ketentuan',
  },
  {
    id: 'kebijakan-privasi',
    name: 'Kebijakan Privasi',
    url: '/kebijakan-privasi',
  },
] as const

export const serviceFeatures = [
  // Ruang GTK
  {
    title: 'Diklat',
    description: 'Pelatihan terbimbing menggunakan LMS.',
    service_id: 'gtk',
    category: 'Belajar Berkelanjutan',
    icon_url: assetUrl('/icon/menu-pelatihan-mandiri.svg'),
    url: process.env.NEXT_PUBLIC_LMS_URL,
    additional_search_keywords: ['guru'],
  },
  {
    title: 'Sertifikasi Pendidik',
    description: 'Pendidikan Profesi Guru (PPG) bagi Guru tertentu.',
    service_id: 'gtk',
    category: 'Belajar Berkelanjutan',
    icon_url: assetUrl('/icon/img-PPG-Daljab.png'),
    url: '/sertifikasi-pendidik',
    additional_search_keywords: ['guru'],
  },
  {
    title: 'Pelatihan Mandiri',
    description: 'Materi untuk pengembangan kompetensi Guru dan Tendik.',
    service_id: 'gtk',
    category: 'Belajar Berkelanjutan',
    icon_url: assetUrl('/icon/menu-pelatihan-mandiri.svg'),
    url: '/pelatihan-mandiri',
    additional_search_keywords: ['guru'],
  },
  {
    title: 'Komunitas',
    description: '144.000+ komunitas Guru dan Tendik berbagi praktik baik.',
    service_id: 'gtk',
    category: 'Belajar Berkelanjutan',
    icon_url: assetUrl('/icon/menu-komunitas.svg'),
    url: '/komunitas',
    additional_search_keywords: ['guru'],
  },
  {
    title: 'Pengelolaan Kinerja',
    description:
      'Perencanaan, pelaksanaan, dan penilaian Anda untuk pengembangan diri dan satdik.',
    service_id: 'gtk',
    category: 'Karir dan Kinerja',
    icon_url: assetUrl('/icon/menu-pengelolaan-kinerja.svg'),
    url: '/pengelolaan-kinerja',
    additional_search_keywords: ['guru'],
  },
  {
    title: 'Seleksi Kepala Sekolah',
    description:
      'Info persyaratan, tahapan, dan cek kualifikasi untuk seleksi.',
    service_id: 'gtk',
    category: 'Karir dan Kinerja',
    icon_url: assetUrl('/icon/menu-seleksi-kepsek.svg'),
    url: '/bcks/selection',
    additional_search_keywords: ['guru'],
  },
  {
    title: 'Refleksi Kompetensi',
    description: 'Rekomendasi pembelajaran yang disusun personal untuk Anda.',
    service_id: 'gtk',
    category: 'Karir dan Kinerja',
    icon_url: assetUrl('/icon/menu-refleksi-kompetensi.png'),
    url: '/refleksi-kompetensi',
    additional_search_keywords: ['guru'],
  },
  {
    title: 'Perangkat Ajar',
    description:
      'Kegiatan intrakurikuler & kokurikuler, buku teks, dan sejenisnya.',
    service_id: 'gtk',
    category: 'Inspirasi Pembelajaran',
    icon_url: assetUrl('/icon/menu-perangkat-ajar.svg'),
    url: '/perangkat-ajar',
    additional_search_keywords: ['guru'],
  },
  {
    title: 'CP/ATP',
    description:
      'Capaian Pembelajaran dan Alur Tujuan Pembelajaran sesuai mata pelajaran Anda.',
    service_id: 'gtk',
    category: 'Inspirasi Pembelajaran',
    icon_url: assetUrl('/icon/menu-cp-atp-alt.svg'),
    url: '/kurikulum/referensi-penerapan/capaian-pembelajaran',
    additional_search_keywords: ['guru'],
  },
  {
    title: 'Ide Praktik',
    description:
      'Artikel dan video terpilih tentang praktik pembelajaran terpusat pada murid.',
    service_id: 'gtk',
    category: 'Inspirasi Pembelajaran',
    icon_url: assetUrl('/icon/ide-praktik.svg'),
    url: '/ide-praktik',
    additional_search_keywords: ['guru'],
  },
  {
    title: 'Bukti Karya',
    description: 'Rekam jejak karya, kinerja, dan kompetensi pendidik.',
    service_id: 'gtk',
    category: 'Inspirasi Pembelajaran',
    icon_url: assetUrl('/icon/menu-bukti-karya-saya.svg'),
    url: '/bukti-karya',
    additional_search_keywords: ['guru'],
  },
  {
    title: 'Video Inspirasi',
    description: 'Inspirasi Pembelajaran',
    service_id: 'gtk',
    category: 'Inspirasi Pembelajaran',
    icon_url: assetUrl('/icon/menu-video-inspirasi.svg'),
    url: '/video-inspirasi',
    additional_search_keywords: ['guru'],
  },
  {
    title: 'Asesmen (Asesmen Murid dan AKM Kelas)',
    description: 'Paket soal dengan pemeriksaan otomatis dan analisis hasil.',
    service_id: 'gtk',
    category: 'Inspirasi Pembelajaran',
    icon_url: assetUrl('/icon/menu-asesmen.svg'),
    url: '/assessment',
    additional_search_keywords: ['guru'],
  },
  {
    title: 'Kelas',
    description:
      'Informasi atau data kelompok murid berdasarkan hasil asesmen.',
    service_id: 'gtk',
    category: 'Inspirasi Pembelajaran',
    icon_url: assetUrl('/icon/menu-kelas.svg'),
    url: '/learning-group',
    additional_search_keywords: ['guru'],
  },
  {
    title: 'Dokumen Rujukan Pengelolaan Kinerja',
    description: 'Panduan umum dan regulasi.',
    service_id: 'gtk',
    category: 'Dokumen Rujukan',
    icon_url: assetUrl('/illustrations/img-flow-process-document.png'),
    url: '/dokumen/kategori/Y7G6ArDWqJ',
    additional_search_keywords: ['guru'],
  },
  {
    title: 'Dokumen Rujukan Pengelolaan Pembelajaran',
    description: 'Panduan umum dan regulasi.',
    service_id: 'gtk',
    category: 'Dokumen Rujukan',
    icon_url: assetUrl('/illustrations/img-flow-process-document.png'),
    url: '/dokumen/kategori/oWx0b8DZ1a',
    additional_search_keywords: ['guru'],
  },
  {
    title: 'Dokumen Rujukan Pengelolaan Satuan Pendidikan',
    description: 'Panduan umum dan regulasi.',
    service_id: 'gtk',
    category: 'Dokumen Rujukan',
    icon_url: assetUrl('/illustrations/img-flow-process-document.png'),
    url: '/dokumen/kategori/o450Zr0mMG',
    additional_search_keywords: ['guru'],
  },
  {
    title: 'Dokumen Rujukan Peningkatan Kompetensi',
    description: 'Panduan umum dan regulasi.',
    service_id: 'gtk',
    category: 'Dokumen Rujukan',
    icon_url: assetUrl('/illustrations/img-flow-process-document.png'),
    url: '/dokumen/kategori/nxo92w0Eem',
    additional_search_keywords: ['guru'],
  },
]

export type ServiceFeature = typeof serviceFeatures[number]
